import { render, staticRenderFns } from "./CulturalVoyageComponent.vue?vue&type=template&id=1c7abbbc&scoped=true&"
import script from "./CulturalVoyageComponent.vue?vue&type=script&lang=js&"
export * from "./CulturalVoyageComponent.vue?vue&type=script&lang=js&"
import style0 from "./CulturalVoyageComponent.vue?vue&type=style&index=0&id=1c7abbbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7abbbc",
  null
  
)

export default component.exports